import { render } from "./BaseCollapse.vue?vue&type=template&id=00022cf2"
import script from "./BaseCollapse.vue?vue&type=script&lang=js"
export * from "./BaseCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__